import LanguageDetector from 'i18next-browser-languagedetector'
import i18next from "i18next"
import resourcesToBackend from "i18next-resources-to-backend"
import {initReactI18next, useTranslation} from "react-i18next"

// Informs i18next where to find the JSON lanaguage files
const resourceLoader = (language, namespace) => import(`./../../locales/${language}/${namespace}.json`)

/**
 * List all the languages supported on the app and is used by both i18n framework and the LocaleSwitcher component.
 */
export const supportedLanguages = {
    en: 'English',
    es: 'Spanish (Español)',
}

/**
 * Initializes the i18next runtime with all the language specific text that the application will be using.
 *
 * @param onSuccess The runtime environment that needs to be able to utilize the i18n text
 * @param onError What to do if an error occurs while attempting to run the service
 */
export const initialize = (onSuccess, onError) => {
    i18next
        .use(LanguageDetector)
        .use(initReactI18next)
        .use(resourcesToBackend(resourceLoader))
        .init({
            debug: false,
            defaultNS: 'navigation',
            fallbackLng: 'en',
            supportedLngs: Object.keys(supportedLanguages),
            ns: [
                'about',
                'footer',
                'home',
                'navigation',
                'navigator',
                'next_steps',
                'procedure_lumpectomy',
                'procedure_mastectomy',
                'procedure_other',
                'resources',
                'sidenav',
                'summary',
                'to_consyder',
                'treatment_options',
                'treatment_table',
                'whats_important',
            ],
        })
        .then(() => {
            onSuccess()
        })
        .catch((e) => {
            if (onError !== undefined && typeof onError === 'function') {
                onError(e);
            } else {
                console.error(e);
            }
        })
}

/**
 * Allows for a lookup against the translations files.
 *
 * @param key Namespace:key to determine the resource to lookup
 * @param opts Any object mapping that can be used to inject variables into the translated text.
 *
 * @returns string
 */
export const __ = (key, opts = undefined) => {
    const { t } = useTranslation()

    return opts ? t(key, opts) : t(key)
}
